import {
  PHASE_SAVE_PHASE_BEGIN,
  PHASE_SAVE_PHASE_SUCCESS,
  PHASE_SAVE_PHASE_FAILURE,
  PHASE_SAVE_PHASE_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';



// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function savePhase(phase, action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PHASE_SAVE_PHASE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/phases';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        phase.phase = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        phase:phase
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            
            dispatch({
              type: PHASE_SAVE_PHASE_SUCCESS,
              data: res,
              action_model:action
            });
            resolve(res);
          }else
          {
            dispatch({
              type: PHASE_SAVE_PHASE_FAILURE,
              data: { error: "Internal error" },
              action_model:action
            });
            reject("Internal Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PHASE_SAVE_PHASE_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSavePhaseError() {
  return {
    type: PHASE_SAVE_PHASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PHASE_SAVE_PHASE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        savePhasePending: true,
        savePhaseError: null,
      };

    case PHASE_SAVE_PHASE_SUCCESS:
      // The request is success
      let fragmentContent = "The phase has been updated with success!";
      let fragmentTitle = "Update Phase";
      let paperTitle = "Update Phase";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The phase has been created with success!'
        fragmentTitle='Create Phase'
        paperTitle='Create Phase'
      }
      // The request is success
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
        savePhasePending: false,
        savePhaseError: null,
      };

    case PHASE_SAVE_PHASE_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Update Phase";
      let paperTitleFail = "Update Phase";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The phase has not been created with success!'
        fragmentTitleFail='Create Phase'
        paperTitleFail='Create Phase'
      }
      // The request is failed
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
        savePhasePending: false,
        savePhaseError: action.data.error,
      };

    case PHASE_SAVE_PHASE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        savePhaseError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/phase/redux/savePhase.js